import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TransporterService } from '../../../services/transporter.service';
import { AuthorityEnum } from '../../../models/enums/authority.enum';
import { HttpResponse } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SidenavComponent } from 'ng-uikit-pro-standard';
import { Transporter } from '../../../models/transporter.model';
import { environment } from '../../../environments/environment';
import { User } from '../../../models/user.model';
import { FaDirectiveEnum } from '../../../models/enums/fa-directive.enum';
import { FeatureUtil } from '../../shared/util/feature-util';

@Component({
  selector: 'jhi-bary-sidebar',
  templateUrl: './bary-sidebar.component.html',
  styleUrls: ['./bary-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BarySidebarComponent implements OnInit {
  private readonly transporterService = inject(TransporterService);
  private readonly accountService = inject(AccountService);

  @Input() transporter!: Transporter;
  @Input() account!: User;
  @Input() isImpersonating = false;
  @Input() swaggerEnabled = true;
  @Input() inProduction = false;

  @Output() goToEvent = new EventEmitter<string>();

  @ViewChild('sidenav') sidenav!: SidenavComponent;

  public _authority = AuthorityEnum;
  public transporters: Transporter[] = [];
  public logo = `${environment.urlApi}api/img/logo-main`;

  protected readonly FAB = FaDirectiveEnum.FAB;

  public ngOnInit(): void {
    if (this.accountService.hasAnyAuthority(AuthorityEnum.ADMIN)) {
      this.transporterService.query().subscribe((res: HttpResponse<Transporter[]>) =>
        (this.transporters = res.body ?? []).sort((a, b) =>
          (a.technicalName ?? '')
            .trim()
            .toLowerCase()
            .localeCompare((b.technicalName ?? '').trim().toLowerCase())
        )
      );
    }
  }

  public hasAnalytics(): boolean {
    return FeatureUtil.isAnalyticsTransporter(this.transporter.technicalName!);
  }

  public handleGoTo(path: string): void {
    this.goToEvent.emit(path);
  }

  public hasRole(role: string): boolean {
    return this.account?.authorities?.includes(role);
  }

  public hasOnlyRole(role: string): boolean {
    return this.hasRole(role) && this.account.authorities.length === 1;
  }
}
